import React from 'react';
import PropTypes from 'prop-types';
import './FormText.scss';

const FormText = (props) => {
  const { name, label, autotestClass, placeholder, maxLength, required, input, meta, meta: { touched, error } } = props;
  const errorClass = meta && touched && error ? 'form-text-error ' : '';
  return (<div className="form-input-container relative">
    <label htmlFor={name}>{label}</label>
    {required && <span className="form-required-text">*</span>}
    <input
      className={`${errorClass}input form-control ${autotestClass}`}
      name={name}
      type="text"
      placeholder={placeholder}
      maxLength={maxLength}
      {...input}
    />
    {errorClass &&
    <span className="form-validation-message">{error}</span>
    }
  </div>);
};

FormText.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  required: PropTypes.bool,
  autotestClass: PropTypes.string,
  placeholder: PropTypes.string,
  maxLength: PropTypes.number,
  input: PropTypes.object,
  meta: PropTypes.object
};

export default FormText;



/** WEBPACK FOOTER **
 ** ./src/components/form/FormText/FormText.js
 **/